export default __webpack_public_path__ + "static/media/waste-water.69c434ef.webp";